import { useState } from 'react';
import { useNavigate } from 'react-router';
import { authClient } from '../auth/client.js';

export function MfaVerify() {
  const nav = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);

  const verify = async () => {
    setError(null);
    try {
      await authClient.twoFactor.verifyTotp({ code });
      nav('/app');
    } catch (e: unknown) {
      setError((e as Error).message);
    }
  };

  return (
    <div className="mx-auto mt-16 max-w-sm rounded border bg-white p-6">
      <h1 className="mb-4 text-xl font-semibold">Verificación 2FA</h1>
      <input
        type="text"
        placeholder="Código TOTP"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        className="w-full rounded border px-3 py-2"
      />
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <button
        type="button"
        onClick={() => void verify()}
        className="mt-3 w-full rounded bg-blue-600 py-2 text-white"
      >
        Verificar
      </button>
    </div>
  );
}
